import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class EstateRole extends BaseModel {
  id?: number;
  name?: string;

  constructor(model: Partial<EstateRole> = {}) {
    super();

    this.id = model.id;
    this.name = model.name;
  }
}
